import { useEffect, useState } from 'react';
import { formatPaymentCurrencyType } from './withdrawAddressConstants';

function resolveChannelLabel(row) {
  if (!row) {
    return '—';
  }
  return row.channelType || row.channelName || row.currencyName || '—';
}

export default function WithdrawAddressEditModal({ open, row, onClose, onSubmit, submitting }) {
  const [walletAddress, setWalletAddress] = useState('');
  const [walletName, setWalletName] = useState('');
  const [bankName, setBankName] = useState('');
  const [error, setError] = useState('');

  const paymentType =
    typeof row?.paymentCurrencyType === 'string'
      ? row.paymentCurrencyType
      : row?.paymentCurrencyType?.name || row?.paymentCurrencyType?.code || '';
  const isBank = paymentType === 'BANK';

  useEffect(() => {
    if (open && row) {
      setWalletAddress(row.withdrawAddress || '');
      setWalletName(row.walletName || '');
      setBankName(row.bankName || '');
      setError('');
    }
  }, [open, row?.id]);

  if (!open || !row) {
    return null;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!walletAddress.trim()) {
      setError('請填寫提現地址');
      return;
    }
    if (isBank && !walletName.trim()) {
      setError('請填寫戶名');
      return;
    }
    setError('');
    await onSubmit({
      id: row.id,
      walletAddress: walletAddress.trim(),
      walletName: isBank ? walletName.trim() : undefined,
      bankName: isBank ? bankName.trim() : undefined,
    });
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--withdraw-address"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>
            修改提現地址 [{row.memberId}]
          </h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <table className="data-table withdraw-address-edit-table">
              <thead>
                <tr>
                  <th>通道</th>
                  <th>出金地址</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="withdraw-address-edit-table__channel">
                      <strong>{resolveChannelLabel(row)}</strong>
                      <span className="withdraw-address-edit-table__meta">
                        {formatPaymentCurrencyType(row.paymentCurrencyType)}
                        {row.currencyName ? ` · ${row.currencyName}` : ''}
                      </span>
                    </div>
                  </td>
                  <td>
                    <input
                      type="text"
                      value={walletAddress}
                      onChange={(e) => setWalletAddress(e.target.value)}
                      className="withdraw-address-edit-table__input"
                      autoComplete="off"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            {isBank && (
              <div className="withdraw-address-edit-extra">
                <div className="form-field">
                  <label htmlFor="editWalletName">
                    <span className="required-mark">*</span> 戶名
                  </label>
                  <input
                    id="editWalletName"
                    type="text"
                    value={walletName}
                    onChange={(e) => setWalletName(e.target.value)}
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="editBankName">開戶行</label>
                  <input
                    id="editBankName"
                    type="text"
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                  />
                </div>
              </div>
            )}

            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer admin-modal__footer--center">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
